import type { ReactNode } from 'react'
import { View } from 'react-native'
import cn from '@ca/ui/utils/cn'

type Props = {
  children: ReactNode
  className?: string
}

export function PanelBox({ children, className }: Props) {
  return (
    <View
      className={cn(
        'overflow-hidden rounded-md border border-black/20 bg-white/60 p-3',
        className
      )}
    >
      {children}
    </View>
  )
}
